import Vue from 'vue';
import 'lazysizes';
import common from './common';

// Add plugins
new Vue(common).$mount('#main-container');
